/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filter_Is_ArchivedInputs */

const en_filter_is_archived = /** @type {(inputs: Filter_Is_ArchivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`archived`)
};

const de_filter_is_archived = /** @type {(inputs: Filter_Is_ArchivedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`archiviert`)
};

/**
* | output |
* | --- |
* | "archived" |
*
* @param {Filter_Is_ArchivedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const filter_is_archived = /** @type {((inputs?: Filter_Is_ArchivedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filter_Is_ArchivedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_filter_is_archived(inputs)
	return en_filter_is_archived(inputs)
});